module.exports = __webpack_public_path__ + "media/images/Network-01-754425a165e83d3c74abed2799dcaecb.svg";